var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('SearchObject', {
    ref: "search",
    attrs: {
      "additional-params": Object.assign({}, _vm.additionalParams),
      "allow-create": _vm.allowCreate,
      "autofocus": _vm.autofocus,
      "base-url": _vm.baseUrl,
      "create-label": _vm.$translate('create_a_catalog'),
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "item-text": _vm.itemText,
      "label": _vm.label || _vm.$translate('select_catalog'),
      "readonly": _vm.readonly,
      "required": _vm.required,
      "value": _vm.value,
      "initial-item": _vm.initialItem,
      "display": "catalog",
      "dense": _vm.dense,
      "outlined": _vm.outlined,
      "error-messages": _vm.errorMessages
    },
    on: {
      "create": _vm.createcatalog,
      "input": _vm.onSearchInput,
      "select": function select($event) {
        return _vm.$emit('select', $event);
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }